import nb from './nativeBridge/index';

export function removeLaunchImage() {
  return new Promise(resolve => {
    // window?.plus?.navigator?.closeSplashscreen();
    resolve();
  });
}

export function openDocument(data) {
  return new Promise((resolve, reject) => {
    nb.openDocument(data, (res) => {
      if (res.success) {
        resolve(res);
      } else {
        reject(new Error(res.msg || '打开文档失败'));
      }
    });
  });
}

export function wxOauth() {
  return new Promise((resolve, reject) => {
    nb.login((res)=>{
      resolve(res);
    })
    // window.wxLoginCallback = (result) => {
    //   resolve(result);
    // };
    // if (window.wxLogin) {
    //   window.wxLogin();
    // } else if (window.android && window.android.wxLogin) {
    //   window.android.wxLogin();
    // } else {
    //   return reject(new Error('Unsupported methods'));
    // }
  });
}


export function shareWithApp(data) {
  return new Promise((resolve, reject) => {
    nb.share(data,(res)=>{
      resolve(res);
    })
    // window.shareWithAppCallback = result => {
    //   reject(new Error('分享完成！'));
    // };
    // if (window.shareWithApp) {
    //   window.shareWithApp(JSON.stringify(data));
    // } else if (window.android && window.android.shareWithApp) {
    //   window.android.shareWithApp(JSON.stringify(data));
    // } else {
    //   return reject(new Error('Unsupported methods'));
    // }
  });
}

export function setBarColor(data) {
  return new Promise((resolve, reject) => {
    // window.setStarusBarColorCallback = result => {
    //   resolve(result);
    // };
    // if (window.setStarusBarColor) {
    //   window.setStarusBarColor(JSON.stringify(data));
    // } else if (window.android && window.android.setStarusBarColor) {
    //   window.android.setStarusBarColor(JSON.stringify(data));
    // }
    resolve();
  });
}

export function showChooseMap(data) {
  return new Promise((resolve, reject) => {
    nb.chooseMap((res)=>{
      console.log(res)
      if (res.success) {
        resolve({
          lat:res.data.latitude,
          lng:res.data.longitude,
          name: res.data.name,
          address: res.data.address,
        });
      } else {
        resolve();
      }
    })
    // window.showChooseMapCallback = result => {
    //   resolve(result);
    // };
    // if (window.showChooseMap) {
    //   window.showChooseMap(JSON.stringify(data));
    // } else if (window.android && window.android.showChooseMap) {
    //   window.android.showChooseMap(JSON.stringify(data));
    // } else {
    //   return reject(new Error('有新版本啦！优化了APP启动速度及用户体验'));
    // }
  });
}


export function getLocation() {
  return new Promise((resolve, reject) => {

    nb.getLocation((res)=>{
      if (res.success) {
        resolve({
         lat:res.data.latitude,
         lng:res.data.longitude,
        });
      } else {
        resolve();
      }
    })

  });
}

export function savePasteboard(data) {
  return new Promise((resolve, reject) => {
    nb.setClipboardData(data,(data)=>{
      resolve(data);
    })
    // window.savePasteboardCallback = result => {
    //   resolve(result);
    // };
    // if (window.savePasteboard) {
    //   window.savePasteboard(data);
    // } else if (window.android && window.android.savePasteboard) {
    //   window.android.savePasteboard(data);
    // } else {
    //   return reject(new Error('Unsupported methods'));
    // }
  });
}

export function showMap(data) {
  return new Promise((resolve, reject) => {
    nb.openLocation(data, (res)=>{
      if (res.success) {
        resolve(res.data)
      }
    })
    // if (window.showMap) {
    //   window.showMap(JSON.stringify(data));
    // } else if (window.android && window.android.showMap) {
    //   window.android.showMap(JSON.stringify(data));
    // } else {
    //   return reject(new Error('有新版本啦！优化了APP启动速度及用户体验'));
    // }
    // resolve();
  });
}

export function getAppInfo() {
  return new Promise((resolve, reject) => {
    // window.getAppInfoCallback = result => {
    //   resolve(result);
    // };
    // if (window.getAppInfo) {
    //   window.getAppInfo();
    // } else if (window.android && window.android.getAppInfo) {
    //   window.android.getAppInfo();
    // } else {
    //   return reject(new Error('Unsupported methods'));
    // }
    resolve({});
  });
}

export function getPhoto(data) {
  return new Promise((resolve, reject) => {

    if(nb.choosePhoto){
      nb.choosePhoto((res)=>{
        console.log(res);
        if (res.success) {
          resolve(res.data)
        }
      })
    }else{
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const base64 = event.target.result.split(',')[1];
            resolve( base64 );
          };
          reader.onerror = () => {
            reject(new Error('读取图片失败'));
          };
          reader.readAsDataURL(file);
        }
      };
      input.click();
    }


    // 开发环境：使用浏览器文件选择



    // window.getPhotoCallback = result => {
    //   resolve(result);
    // };
    // if (window.getPhoto) {
    //   window.getPhoto(JSON.stringify(data));
    // } else if (window.android && window.android.getPhoto) {
    //   window.android.getPhoto();
    // } else {
    //   return reject(new Error('有新版本啦！优化了APP启动速度及用户体验'));
    // }
  });
}

export function doDownLoadUpdateFile(data) {
  if (window.getPhoto) {
    window.doDownLoadUpdateFile(JSON.stringify(data));
  } else if (window.android && window.android.doDownLoadUpdateFile) {
    window.android.doDownLoadUpdateFile(JSON.stringify(data));
  }
}

// 开启更新
export function doUpdateInstallFile(data) {
  if (window.getPhoto) {
    window.doUpdateInstallFile(JSON.stringify(data));
  } else if (window.android && window.android.doUpdateInstallFile) {
    window.android.doUpdateInstallFile(JSON.stringify(data));
  }
}

/**
 * 跳转到微信小程序
 * @param {Object} data - 跳转参数
 * @param {string} data.userName - 小程序原始ID（gh_xxx格式）
 * @param {string} data.path - 小程序页面路径（可带参数）
 * @param {number} data.miniProgramType - 小程序版本：0正式版 1开发版 2体验版
 * @returns {Promise}
 */
export function launchMiniProgram(data) {
  wx.miniProgram.navigateTo({ url: '/pages/toShare/toShare?data='+encodeURIComponent(JSON.stringify(data)) });
}

/**
 * 选择图片（从相册或相机）
 * @param {Object} data - 参数配置
 * @param {number} data.type - 选择类型：1相册 2相机 0或不传则弹出选择
 * @returns {Promise<string>} 返回图片的本地路径或base64
 */
export function chooseImage(data = {}) {
  return new Promise((resolve, reject) => {
    // 优先使用 nativeBridge
    if (nb.choosePhoto) {
      nb.choosePhoto((res) => {
        if (res.success) {
          resolve(res.data);
        } else {
          reject(new Error(res.message || '未选择图片'));
        }
      });
    } else if (window.getPhoto) {
      window.getPhotoCallback = result => {
        if (result && (result.path || result.base64 || result.url)) {
          resolve(result.path || result.base64 || result.url || result);
        } else if (typeof result === 'string') {
          resolve(result);
        } else {
          reject(new Error('未选择图片'));
        }
      };
      window.getPhoto(JSON.stringify(data));
    } else if (window.android && window.android.getPhoto) {
      window.getPhotoCallback = result => {
        if (result && (result.path || result.base64 || result.url)) {
          resolve(result.path || result.base64 || result.url || result);
        } else if (typeof result === 'string') {
          resolve(result);
        } else {
          reject(new Error('未选择图片'));
        }
      };
      window.android.getPhoto(JSON.stringify(data));
    } else {
      // H5 环境降级处理：使用浏览器文件选择
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            resolve(event.target.result);
          };
          reader.onerror = () => {
            reject(new Error('读取图片失败'));
          };
          reader.readAsDataURL(file);
        } else {
          reject(new Error('未选择图片'));
        }
      };
      input.click();
    }
  });
}

/**
 * 上传图片到服务器
 * @param {string} imagePath - 图片路径或base64
 * @returns {Promise<string>} 返回上传后的图片URL
 */
export async function uploadImage(imagePath) {
  // 如果已经是网络图片URL，直接返回
  if (imagePath && imagePath.startsWith('http')) {
    return imagePath;
  }

  // 调用上传接口
  return new Promise((resolve, reject) => {
    window.uploadImageCallback = result => {
      if (result && result.url) {
        resolve(result.url);
      } else if (typeof result === 'string' && result.startsWith('http')) {
        resolve(result);
      } else {
        reject(new Error('上传失败'));
      }
    };

    if (window.uploadImage) {
      window.uploadImage(imagePath);
    } else if (window.android && window.android.uploadImage) {
      window.android.uploadImage(imagePath);
    } else {
      // 开发环境，模拟返回
      console.log('上传图片:', imagePath);
      resolve(imagePath);
    }
  });
}
